// ── API Endpoints (SANS préfixe /api — le client axios l'ajoute) ──
// Centralise les endpoints du module pointage.

import type { PointageBloc, PointageType } from "../types/pointageSelf";

export const API_ENDPOINTS = {
  PUBLIC_CONFIG: "/public/pointage/config",
  PUBLIC_SUBMIT: "/public/pointage",
  PUBLIC_CONTEXT: "/public/pointage/context",
  PUBLIC_SITE: "/public/pointage/site",
  SELF_CONTEXT: "/pointage/me/context",
  SELF_SUBMIT: "/pointage/me",
} as const;

export const BLOC_LABEL: Record<PointageBloc, string> = {
  MATIN: "Matin",
  APRES_MIDI: "Après-midi",
};

export const TYPE_LABEL: Record<PointageType, string> = {
  ARRIVEE: "Arrivée",
  DEPART: "Départ",
  PRESENCE: "Présence",
};

export const MODE_LABEL: Record<string, string> = {
  TABLETTE: "Tablette",
  PC: "PC",
  VARIABLE: "Variable",
  DEMI_JOURNEE: "Demi-journée",
  NONE: "Aucun",
};
